// extracted by mini-css-extract-plugin
export var button = "step_catch_text-module--button--39c61";
export var step = "step_catch_text-module--step--116d0";
export var text = "step_catch_text-module--text--3369e";
export var wrapper = "step_catch_text-module--wrapper--c1c42";